// import React, { useContext } from "react";
// // import { techStack } from "../constants";
// import heroBg from "../assets/newimages.png";
// import { ThemeContext } from "../themeProvider";
// import { motion } from "framer-motion";
// import { contactLinks } from "../constants";

// const About = () => {
//   const theme = useContext(ThemeContext);
//   const darkMode = theme.state.darkMode;
//   return (
//     <div
//       id="about"
//       className={darkMode === true ? "bg-gray-100" : "bg-gray-700"}
//     >
//       <div className="max-w-7xl mx-auto x-2 sm:px-3 lg:px-4 px-2">
//         <h2
//           className={
//             darkMode
//               ? "text-5xl font-bold px-4 md:px-0 text-center"
//               : "text-5xl font-bold px-4 md:px-0 text-center text-white"
//           }
//         >
//           ABOUT ME
//         </h2>
//         <div className="flex" style={{ width: "90%" }}>
//           <div>
//             <motion.img
//               initial="hidden"
//               whileInView={"visible"}
//               variants={{
//                 visible: {
//                   y: 0,
//                   opacity: 1,

//                   transition: {
//                     type: "spring",
//                   },
//                 },
//                 hidden: { opacity: 1, y: 80 },
//               }}
//               src={heroBg}
//               alt=""
//               className="md:w-6/3 hidden sm:block"
//               style={{
//                 height: "80%",
//                 width: "80%",
//                 borderRadius: "100%",
//                 // margin: "3px",
//               }}
//             />
//           </div>
//           <div>
//             <motion.div>
//               <p
//                 className={
//                   darkMode
//                     ? "mt-4 text-xl text-justify"
//                     : "mt-4 text-xl text-justify text-white"
//                 }
//               >
//                 {/* Observant and detail-oriented aspiring full-stack developer with a specialization in MERN stack. Self-motivated and curious, with a keen interest in building user-centric products. Looking forward to hone my skills in a challenging work environment. */}
//                 {/* Hi, I'm Manoj Kumar. I completed my B.Tech in Computer Science
//                 and Engineering from Anand College of Engineering and
//                 Management, Kapurthala, Punjab, along with a Full Stack Web
//                 Development course from Masai School where I learned MERN stack
//                 and Data Structure & Algorithms. I have previous experience as a
//                 Team Leader at NSB BPO Solution Pvt Ltd, and I am currently
//                 working at Indusnet Technologies Pvt Ltd in Kolkata as a MERN
//                 Stack web developer since September 2022. I'm a self-learner,
//                 always eager to explore and acquire new knowledge, believing
//                 that even small information can make a big impact. Check out my
//                 GitHub for projects or my resume for more details. */}
//                 Experienced Full Stack Developer with 1.9 year of experience in
//                 MERN technologies. Committed to delivering high-quality
//                 solutions, currently working as a Full Stack Developer and
//                 actively seeking opportunities to contribute my skills to
//                 impactful projects
//               </p>

//               <ul className="flex">
//                 {contactLinks.map((el) => (
//                   <div>
//                     <a
//                       target={"_blank"}
//                       rel="noreferrer"
//                       href={el.link}
//                       className="md:ml-6 md:mr-0 mr-6 cursor-pointer mt-4 hover:scale-125 flex flex-col justify-center items-center"
//                     >
//                       <img alt="" src={el.url} style={{ height: "40px" }} />
//                       <p
//                         className={
//                           darkMode
//                             ? "text-md mt-2 hover:hidden"
//                             : "text-md mt-2 hover:hidden text-white"
//                         }
//                       >
//                         {el.name}
//                       </p>
//                     </a>
//                   </div>
//                 ))}
//               </ul>
//             </motion.div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default About;






import React, { useContext } from "react";
import heroBg from "../assets/newimages.png";
import { ThemeContext } from "../themeProvider";
import { motion } from "framer-motion";
import { contactLinks } from "../constants";

const About = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div
      id="about"
      className={darkMode ? "bg-gray-100" : "bg-gray-700"}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className={
            darkMode
              ? "text-5xl font-bold text-center"
              : "text-5xl font-bold text-center text-white"
          }
        >
          ABOUT ME
        </h2>
        <div className="flex flex-col md:flex-row items-center md:items-start mt-8">
          <div className="w-full md:w-1/2 flex justify-center md:justify-start mb-8 md:mb-0">
            <motion.img
              initial="hidden"
              whileInView="visible"
              variants={{
                visible: {
                  y: 0,
                  opacity: 1,
                  transition: { type: "spring" },
                },
                hidden: { opacity: 1, y: 80 },
              }}
              src={heroBg}
              alt=""
              className="rounded-full"
              style={{ height: "80%", width: "80%" }}
            />
          </div>
          <div className="w-full md:w-1/2">
            <motion.div>
              <p
                className={
                  darkMode
                    ? "mt-4 text-xl text-justify"
                    : "mt-4 text-xl text-justify text-white"
                }
              >
                Experienced Full Stack Developer with 1.9 years of experience in
                MERN technologies. Committed to delivering high-quality
                solutions, currently working as a Full Stack Developer and
                actively seeking opportunities to contribute my skills to
                impactful projects.
              </p>
              <ul className="flex justify-center md:justify-start mt-4">
                {contactLinks.map((el, index) => (
                  <li key={index} className="mx-2 md:mx-4">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={el.link}
                      className="cursor-pointer hover:scale-125 flex flex-col items-center"
                    >
                      <img alt={el.name} src={el.url} style={{ height: "40px" }} />
                      <p
                        className={
                          darkMode
                            ? "text-md mt-2 text-center"
                            : "text-md mt-2 text-center text-white"
                        }
                      >
                        {el.name}
                      </p>
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
